import React from 'react';
import {getDescriber} from '../../descriptor/DescriptorType';
import Settings from '../../../../../Settings';
import CollapsibleComponent from '../../../../elements/CollapsibleComponent';
import AVText from '../../../../elements/AVText';
import {FAQ} from '../utils/faqConfig';

export const FAQItem: React.FC<{faq: FAQ; index: number}> = React.memo(
  ({faq, index}) => {
    const {getHelpStyleDescriptor} = getDescriber();
    const isRefiveOr365Pay = Settings.isRefiveAnd365Pay();

    return (
      <CollapsibleComponent
        headerAccessibilityLabel={faq.question}
        contentAccessibilityLabel={faq.answer}
        header={
          <AVText style={getHelpStyleDescriptor(isRefiveOr365Pay)?.question}>
            {faq.question}
          </AVText>
        }
        content={
          <AVText
            accessible={true}
            accessibilityLabel={faq.answer}
            style={getHelpStyleDescriptor(isRefiveOr365Pay)?.answer}
          >
            {faq.answer}
          </AVText>
        }
        key={index}
        testID="qa_txt_Question"
      />
    );
  },
);
